import { FilterOutlined } from '@ant-design/icons';
import { Avatar, Input, Modal, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import styled from 'styled-components';

export const ModalGlobalStyle = styled(Modal)`
  .ant-modal-header {
    background-color: rgba(239, 244, 247, 1);
  }
  .ant-modal-footer {
    background-color: rgba(239, 244, 247, 1);
  }
  
  &.ant-modal-wrap {
    overflow: hidden;
  }
  
  .ant-modal-content {
    max-height: 90vh;
    display: flex;
    flex-direction: column;
  }
  
  .ant-modal-body {
    overflow-y: auto;
    max-height: 60vh;
  }
`;

export const StyledAvatar = styled(Avatar)`
  background: #008080;
  vertical-align: middle;
  margin-right: 12px;
`;

export const StyledContentRow = styled(Row)`
  padding: 12px;
  border: 0.5px solid rgba(0, 0, 0, 0.15);
  justify-content: space-between;
`;

export const StyledName = styled(Text)`
  font-weight: 700;
  font-size: 14px;
`;

export const StyledSearchInput = styled(Input)`
  margin-bottom: 16px;
  min-width: 100%;
`;

export const StyledFilterIcon = styled(FilterOutlined)`
  opacity: 0.25;
`;

export const StyledRole = styled(Text)`
  font-weight: 400;
  font-size: 14px;
`;

export const StyledMainPartRow = styled(Text)`
  display: flex;
  align-items: center;
`;
